module.exports = __webpack_public_path__ + "static/media/windsurfing_1366.2ff461b6.webp";